<template>
  <div id="app" :class="{ 'global-gray-filter': isGlobalGrayFilter }">
    <router-view/>
  </div>
</template>

<script>
import { homeApi } from '@/api/index'

export default {
  name: 'App',
  data() {
    return {
      isGlobalGrayFilter: false
    }
  },
  created() {
    // 监听全局灰色滤镜事件
    this.$root.$on('setGlobalGrayFilter', this.setGlobalGrayFilter);
  },
  mounted() {
    // 页面加载时获取灰色滤镜状态
    this.getGary();
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('setGlobalGrayFilter', this.setGlobalGrayFilter);
  },
  methods: {
    setGlobalGrayFilter(isGray) {
      this.isGlobalGrayFilter = isGray;
    },
    async getGary() {
      try {
        let params = {}
        
        const response = await homeApi.getGary(params)
      
        if (response && response.code === 0) {
          if(response.data.effectFilter == 1){
            // 触发全局灰色滤镜事件
            this.$root.$emit('setGlobalGrayFilter', true);
          } else {
            // 关闭全局灰色滤镜
            this.$root.$emit('setGlobalGrayFilter', false);
          }
        }
        
      } catch (error) {
        console.error('获取灰色滤镜状态异常:', error)
       
      } finally {
        // 隐藏加载状态
        
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  transition: filter 0.3s ease;
}

#app.global-gray-filter {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
}

#app.global-gray-filter * {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
}


</style>
